import React from "react";
import ResponsiveMasonry from "react-masonry-css";
import "./CardSkeleton.css";

const skeletonGridBreakpoints = {
  default: 5,
  1535: 4,
  1279: 3,
  1023: 2,
  767: 1,
};

export function CardSkeleton({ className = "" }) {
  const shapeClass = "card-skeleton__shape";

  return (
    <article
      className={`card-skeleton min-h-[480px] overflow-hidden rounded-3xl border shadow-sm ${className}`}
      aria-hidden="true"
    >
      <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3 dark:border-white/10">
        <div className="flex min-w-0 flex-1 items-center gap-3">
          <div className={`${shapeClass} h-9 w-9 flex-shrink-0 rounded-full`} />
          <div className="min-w-0 flex-1 space-y-2">
            <div className={`${shapeClass} h-3.5 w-2/3 rounded-full`} />
            <div className={`${shapeClass} h-2.5 w-1/3 rounded-full`} />
          </div>
        </div>
        <div className="ml-3 flex gap-2">
          <div className={`${shapeClass} h-7 w-7 rounded-lg`} />
          <div className={`${shapeClass} h-7 w-7 rounded-lg`} />
        </div>
      </div>

      <div className="space-y-3 px-4 py-4">
        <div className={`${shapeClass} h-4 w-4/5 rounded-full`} />
        <div className={`${shapeClass} h-3 w-full rounded-full`} />
        <div className={`${shapeClass} h-3 w-11/12 rounded-full`} />
        <div className={`${shapeClass} h-3 w-3/5 rounded-full`} />
      </div>

      <div className={`${shapeClass} mx-4 h-60 rounded-2xl`} />

      <div className="mt-4 flex items-center justify-between border-t border-gray-200 px-4 py-3 dark:border-white/10">
        <div className="flex gap-2">
          <div className={`${shapeClass} h-7 w-14 rounded-full`} />
          <div className={`${shapeClass} h-7 w-10 rounded-full`} />
        </div>
        <div className="flex gap-2">
          <div className={`${shapeClass} h-7 w-7 rounded-full`} />
          <div className={`${shapeClass} h-7 w-7 rounded-full`} />
        </div>
      </div>
    </article>
  );
}

export function CardSkeletonGrid({ count = 5, className = "" }) {
  return (
    <div className={className} role="status" aria-live="polite" aria-label="Loading cards">
      <ResponsiveMasonry
        breakpointCols={skeletonGridBreakpoints}
        className="card-masonry flex -ml-4 w-auto"
        columnClassName="card-masonry__column pl-4 bg-clip-padding"
      >
        {Array.from({ length: count }, (_, index) => (
          <div key={index} className="mb-4 inline-block w-full break-inside-avoid">
            <CardSkeleton />
          </div>
        ))}
      </ResponsiveMasonry>
      <span className="sr-only">Loading cards...</span>
    </div>
  );
}

export default CardSkeleton;
